/* eslint-disable camelcase */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

import { registerField } from 'core/forms';

import { Select } from 'uikit/selects';

import CatalogActivityListItem from '@/exceed/components/catalogActivityListItem';

import styles from '../styles/formFieldCatalogActivity.module.scss';

const FormFieldCatalogActivity = ({ fieldId, schema, updateField, value = [] }) => {
  const isEmptyValue = !value || value.length === 0;
  const { contentId, loadOptions, sortSelectedOptionsBy } = schema;
  const [searchValue, setSearchValue] = useState('');
  const [options, setOptions] = useState([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);

  const onChange = ({ id }) => {
    const newValue = {
      material_type: 'Course',
      material_id: id,
      status: 'created',
    };

    updateField(sortBy([...value, newValue], sortSelectedOptionsBy));
  };

  const onLoadOptions = async (searchQuery) => {
    setIsLoadingOptions(true);

    const loadedOptions = (await loadOptions(searchQuery)) || [];

    setIsLoadingOptions(false);

    const newOptions = loadedOptions.filter(
      (option) =>
        !(value || []).some(({ material_id }) => material_id === option.id) &&
        option.id !== contentId,
    );

    setOptions(newOptions);

    return newOptions;
  };

  const onInputChange = useCallback((newValue) => {
    setSearchValue(newValue);
  }, []);

  const onRemove = (removeActivity) => {
    const filteredValue = value.filter((activity) => !isEqual(activity, removeActivity));
    updateField(filteredValue);
  };

  useEffect(() => {
    onLoadOptions(searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className={styles.element} id={fieldId}>
      {!isEmptyValue && (
        <ul className={styles.list}>
          {value.map((item, index) => (
            <CatalogActivityListItem
              // eslint-disable-next-line react/no-array-index-key
              key={`source_material_${index}`}
              onRemove={() => onRemove(item)}
              id={item.material_id}
            />
          ))}
        </ul>
      )}
      <Select
        className={styles.select}
        defaultOptions={options}
        inputValue={searchValue}
        isAsync
        isFluid
        isLoading={isLoadingOptions && !options.length}
        isSearchable
        loadOptions={onLoadOptions}
        onChange={onChange}
        onInputChange={onInputChange}
        value={null}
      />
    </div>
  );
};

FormFieldCatalogActivity.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    contentId: PropTypes.number,
    loadOptions: PropTypes.func.isRequired,
    sortSelectedOptionsBy: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      material_type: PropTypes.oneOf(['Course', 'Resource']).isRequired,
      material_id: PropTypes.number.isRequired,
      status: PropTypes.oneOf([
        'created',
        'failure',
        'rag_token_requested',
        'request_file_transcript',
        'requested',
        'success',
      ]).isRequired,
    }),
  ),
};

registerField('CatalogActivity', FormFieldCatalogActivity);

export default FormFieldCatalogActivity;
